import { useScrollAnimation } from '../../../hooks/useScrollAnimation';

export default function Problems() {
  const { ref, isVisible } = useScrollAnimation();

  const problems = [
    {
      icon: 'ri-team-line',
      title: 'Workforce Stress',
      description: 'Short staffing, high turnover, and overwhelmed caregivers'
    },
    {
      icon: 'ri-file-list-3-line',
      title: 'Compliance Pressure',
      description: 'Documentation that falls behind and inspections that create anxiety'
    },
    {
      icon: 'ri-alert-line',
      title: 'Operational Chaos',
      description: 'Paperwork overload, communication gaps, and daily fires that never stop'
    }
  ];

  return (
    <section ref={ref as React.RefObject<HTMLElement>} className="py-20 bg-gray-50">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className={`text-center mb-16 ${isVisible ? 'opacity-100 animate-fade-in-up' : 'opacity-0'}`}>
          <h2 className="text-4xl md:text-5xl font-bold text-gray-900 mb-6">
            The Problems We Solve
          </h2>
        </div>

        <div className="grid md:grid-cols-3 gap-8">
          {problems.map((problem, index) => (
            <div 
              key={index}
              className={`bg-white p-8 rounded-xl shadow-lg hover-lift ${
                isVisible ? 'opacity-100 animate-scale-in' : 'opacity-0'
              }`}
              style={{ animationDelay: `${index * 0.15 + 0.2}s` }}
            >
              <div className="w-16 h-16 flex items-center justify-center bg-teal-100 rounded-full mb-6 mx-auto">
                <i className={`${problem.icon} text-3xl text-teal-600`}></i>
              </div>
              <h3 className="text-2xl font-bold text-gray-900 mb-4 text-center">
                {problem.title}
              </h3>
              <p className="text-gray-700 text-center leading-relaxed">
                {problem.description}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
